import { render, staticRenderFns } from "./C2D.vue?vue&type=template&id=0af27f28&scoped=true"
import script from "./C2D.vue?vue&type=script&lang=js"
export * from "./C2D.vue?vue&type=script&lang=js"
import style0 from "./C2D.vue?vue&type=style&index=0&id=0af27f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af27f28",
  null
  
)

export default component.exports